import {
    AgreementValueStringified,
    EditChildForParentFormFields,
    UpdateChildForParentDTO,
} from 'types';

export const parseEditChildForParentFormFieldsIntoUpdateChildForParentDTO: (
    childFormFields: EditChildForParentFormFields,
) => UpdateChildForParentDTO = (childFormFields) => {
    const address =
        !childFormFields.street && !childFormFields.zipCode && !childFormFields.city
            ? null
            : {
                  street: childFormFields.street || null,
                  zipCode: childFormFields.zipCode || null,
                  city: childFormFields.city || null,
              };

    return {
        address,
        diseases: childFormFields.diseases,
        allergies: childFormFields.allergens,
        agreements: {
            facebook:
                childFormFields.socialNetworksImageSharingAgreementFacebook as AgreementValueStringified,
            instagram:
                childFormFields.socialNetworksImageSharingAgreementInstagram as AgreementValueStringified,
            tiktok: childFormFields.socialNetworksImageSharingAgreementTikTok as AgreementValueStringified,
            website:
                childFormFields.socialNetworksImageSharingAgreementWebsite as AgreementValueStringified,
        },
    };
};
